<template>
  <div class="giardino-slider">
    <carousel  
    :navigationEnabled="false"
    :loop="true"
    :paginationEnabled="false"
    :perPage="1"
    :autoplay="true"
    >
      <slide class="slide" v-for="(foto, index) in giardinopics" :key="index">
        <img
          :src="`${siteBase}/${foto.foto}`"
          alt="giardino photo"
          draggable="false"
        />
      </slide>

    </carousel>
  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';
import { SITE_BASE, siteApiUrl } from "@/siteBase.js";

export default {
  name: "GiardinoSlider",
  components: {
     Carousel,
    Slide
  },

  computed: {
    siteBase() {
      return SITE_BASE;
    },
  },

  data() {
    return {
      giardinopics:[],
    };
  },

  async mounted() {
    let data = await fetch(siteApiUrl("api/giardino-slideshow.json"));
    let giardinopics = await data.json()

    this.giardinopics = giardinopics;
  }
};
</script>

<style>
</style>